import BuildingInfos from './BuildingInfo';

export default BuildingInfos;
